export interface LoginResponse {
    clientId: number;
    success: boolean;
    fullName: string;
    message: string;
    token: string;
    refreshToken: string;
    code: String;
    localizedMessage: string;
    status: Number;
}

export class TokenResponse {
    scopes: String[];
}

export interface OauthResponse {
    authUrl: string;
    providerKey: string;
	providerName: string;
}